var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackofficeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "workspace copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-41.000000, -132.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "workspace-copy-7",
    transform: "translate(41.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.08,10.7391304 L10.08,17.3478261 L1.68,17.3478261 L1.68,10.7391304 L10.08,10.7391304 M10.08,9.08695652 L1.68,9.08695652 C0.75216162,9.08695652 0,9.82665998 0,10.7391304 L0,17.3478261 C0,18.2602965 0.75216162,19 1.68,19 L10.08,19 C11.0078384,19 11.76,18.2602965 11.76,17.3478261 L11.76,10.7391304 C11.76,9.82665998 11.0078384,9.08695652 10.08,9.08695652 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32,1.65217391 L19.32,5.7826087 L10.92,5.7826087 L10.92,1.65217391 L19.32,1.65217391 M19.32,0 L10.92,0 C9.99216162,0 9.24,0.739703457 9.24,1.65217391 L9.24,5.7826087 C9.24,6.69507915 9.99216162,7.43478261 10.92,7.43478261 L19.32,7.43478261 C20.2478384,7.43478261 21,6.69507915 21,5.7826087 L21,1.65217391 C21,0.739703457 20.2478384,0 19.32,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32,10.7391304 L19.32,14.8695652 L15.12,14.8695652 L15.12,10.7391304 L19.32,10.7391304 M19.32,9.08695652 L15.12,9.08695652 C14.1921616,9.08695652 13.44,9.82665998 13.44,10.7391304 L13.44,14.8695652 C13.44,15.7820357 14.1921616,16.5217391 15.12,16.5217391 L19.32,16.5217391 C20.2478384,16.5217391 21,15.7820357 21,14.8695652 L21,10.7391304 C21,9.82665998 20.2478384,9.08695652 19.32,9.08695652 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88,1.65217391 L5.88,5.7826087 L1.68,5.7826087 L1.68,1.65217391 L5.88,1.65217391 M5.88,0 L1.68,0 C0.75216162,0 0,0.739703457 0,1.65217391 L0,5.7826087 C0,6.69507915 0.75216162,7.43478261 1.68,7.43478261 L5.88,7.43478261 C6.80783838,7.43478261 7.56,6.69507915 7.56,5.7826087 L7.56,1.65217391 C7.56,0.739703457 6.80783838,0 5.88,0 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackofficeActive);
export default __webpack_public_path__ + "static/media/backoffice-active.c56054ccdf360e3b4acbbd0680f13efe.svg";
export { ForwardRef as ReactComponent };